import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteMyAccount } from "slices/authSlice";

const AccountDelete = () => {
  const dispatch = useDispatch();
  const [inputState, setInputState] = useState("");
  return (
    <div>
      <div>
        Are you sure you want to delete your EfficeSpace account and personal
        details (chat text will not be deleted)? This cannot be reversed.
      </div>
      <br></br>
      <div>
        Please type <em>"delete"</em> to confirm.{" "}
      </div>
      <br></br>
      <input
        className="input-box"
        onChange={(e) => {
          setInputState(e.target.value);
        }}
        value={inputState}
        placeholder="delete"
      ></input>
      <br></br>
      <br></br>
      <div
        className="confirm-button delete-bg-color"
        onClick={() => {
          if (inputState === "delete") {
            dispatch(deleteMyAccount());
          }
        }}
      >
        Yes I understand, delete my account.
      </div>
    </div>
  );
};

export default AccountDelete;
